import Enumerator from '../global/Enumerator';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';

export const householdExpenseTypes = [
  'food_and_supermarket',
  'coffees_lunches_takeaway',
  'entertainment',
  'domestic_holidays',
  'gym_fees_sport_other_health_and_wellness',
  'cigarettes_and_alcohol',
  'clothing_shoes_and_accessories',
  'hairdressing_and_grooming',
  'phone_internet_and_pay_tv',
  'media_streaming_and_subscription_services',
  'gifts_and_celebrations',
  'other_discretionary_expenses',
  'recreational_vehicle_running_costs',
  'pets',
  'public_education_costs',
  'private_education_costs',
  'tertiary_and_vocational_education',
  'childcare',
  'child_or_spousal_maintenance',
  'private_health_insurance',
  'doctor_dentist_pharmacy_glasses',
  'life_trauma_income_insurance',
  'essential_vehicle_running_cost',
  'public_transport_taxis_and_ride_share_commuting_airfares',
  'essential_vehicle_insurance',
  'current_rent_expense',
  'ongoing_board_expense',
  'primary_residence_running_costs',
  'primary_residence_body_corp',
  'secondary_residence_running_costs',
  'secondary_residence_body_corp',
  'investment_property_running_costs',
  'investment_property_body_corp'
];

export class HouseholdExpenseType extends Enumerator {
  static default() {
    return this.of('food_and_supermarket');
  }
}

HouseholdExpenseType.initEnum({
  food_and_supermarket: {
    get title() {
      return 'Food & supermarket';
    },
    get titleNZ() {
      return 'Food & supermarket';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  coffees_lunches_takeaway: {
    get title() {
      return 'Coffees, lunches takeaway';
    },
    get titleNZ() {
      return 'Coffees, lunches takeaway';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  entertainment: {
    get title() {
      return 'Entertainment';
    },
    get titleNZ() {
      return 'Entertainment';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  domestic_holidays: {
    get title() {
      return 'Domestic holidays';
    },
    get titleNZ() {
      return 'Domestic holidays';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  gym_fees_sport_other_health_and_wellness: {
    get title() {
      return 'Gym fees, sport, other health & wellness';
    },
    get titleNZ() {
      return 'Gym fees, sport, other health & wellness';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  cigarettes_and_alcohol: {
    get title() {
      return 'Cigarettes & alcohol';
    },
    get titleNZ() {
      return 'Cigarettes & alcohol';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  clothing_shoes_and_accessories: {
    get title() {
      return 'Clothing, shoes & accessories';
    },
    get titleNZ() {
      return 'Clothing, shoes & accessories';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  hairdressing_and_grooming: {
    get title() {
      return 'Hairdressing & grooming';
    },
    get titleNZ() {
      return 'Hairdressing & grooming';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  phone_internet_and_pay_tv: {
    get title() {
      return 'Phone, Internet & pay TV';
    },
    get titleNZ() {
      return 'Phone, Internet & pay TV';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  media_streaming_and_subscription_services: {
    get title() {
      return 'Media streaming & subscription services';
    },
    get titleNZ() {
      return 'KiwiSaver';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  gifts_and_celebrations: {
    get title() {
      return 'Gifts & celebrations';
    },
    get titleNZ() {
      return 'Gifts & celebrations';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  other_discretionary_expenses: {
    get title() {
      return 'Other discretionary expenses';
    },
    get titleNZ() {
      return 'Other discretionary expenses';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  recreational_vehicle_running_costs: {
    get title() {
      return 'Recreational vehicle running costs';
    },
    get titleNZ() {
      return 'Transport costs';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  pets: {
    get title() {
      return 'Pets';
    },
    get titleNZ() {
      return 'Pets';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  public_education_costs: {
    get title() {
      return 'Public education costs';
    },
    get titleNZ() {
      return 'Public education costs';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  private_education_costs: {
    get title() {
      return 'Private education costs';
    },
    get titleNZ() {
      return 'Private education costs';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  tertiary_and_vocational_education: {
    get title() {
      return 'Tertiary & vocational education';
    },
    get titleNZ() {
      return 'Tertiary & vocational education';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  childcare: {
    get title() {
      return 'Childcare';
    },
    get titleNZ() {
      return 'Childcare';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  child_or_spousal_maintenance: {
    get title() {
      return 'Child or spousal maintenance';
    },
    get titleNZ() {
      return 'Child or spousal maintenance';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  private_health_insurance: {
    get title() {
      return 'Private health insurance';
    },
    get titleNZ() {
      return 'Private health insurance';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  doctor_dentist_pharmacy_glasses: {
    get title() {
      return 'Doctor, dentist, pharmacy, glasses';
    },
    get titleNZ() {
      return 'Doctor, dentist, pharmacy, glasses';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  life_trauma_income_insurance: {
    get title() {
      return 'Life, trauma, income insurance';
    },
    get titleNZ() {
      return 'Life, trauma, income insurance';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  essential_vehicle_running_cost: {
    get title() {
      return 'Essential vehicle running cost';
    },
    get titleNZ() {
      return 'Motor vehicle expenses';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  public_transport_taxis_and_ride_share_commuting_airfares: {
    get title() {
      return 'Public transport, taxis & ride share, commuting airfares';
    },
    get titleNZ() {
      return 'Public transport, taxis & ride share, commuting airfares';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  essential_vehicle_insurance: {
    get title() {
      return 'Essential vehicle insurance';
    },
    get titleNZ() {
      return 'Essential vehicle insurance';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  current_rent_expense: {
    get title() {
      return 'Current rent expense';
    },
    get titleNZ() {
      return 'Current rent expense';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  ongoing_board_expense: {
    get title() {
      return 'Ongoing board expense';
    },
    get titleNZ() {
      return 'Ongoing board expense';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  primary_residence_running_costs: {
    get title() {
      return 'Primary residence running costs';
    },
    get titleNZ() {
      return 'Rates';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  primary_residence_body_corp: {
    get title() {
      return 'Primary residence land tax';
    },
    get titleNZ() {
      return 'Body corporate';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  secondary_residence_running_costs: {
    get title() {
      return 'Secondary residence running costs';
    },
    get titleNZ() {
      return 'Home & contents insurance';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  secondary_residence_body_corp: {
    get title() {
      return 'Secondary residence body corp';
    },
    get titleNZ() {
      return 'Utilities and maintenance';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  investment_property_running_costs: {
    get title() {
      return 'Investment property running costs';
    },
    get titleNZ() {
      return 'Investment property costs';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  },
  investment_property_body_corp: {
    get title() {
      return 'Investment property body corp';
    },
    get titleNZ() {
      return 'Investment body corp';
    },
    get frequency() {
      return PaymentFrequency.monthly.name;
    }
  }
});

export default {
  householdExpenseTypes,
  HouseholdExpenseType
};
